/* eslint no-shadow: ["error", { "allow": ["state"] }] */
/* eslint no-param-reassign: ["error", { "props": false }] */

const state = {
  isMobileScreen: window.outerWidth < 777,
};

const getters = {
  isMobileScreen: state => state.isMobileScreen,
};

const mutations = {
  resize(state) {
    state.isMobileScreen = window.outerWidth < 777; /* actual < 760 */
  },
};

window.addEventListener('resize', () => mutations.resize(state), false);

export default {
  namespaced: true,
  state,
  getters,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/screen/screen.js